module.exports = __webpack_public_path__ + "static/media/photo.b34a526d.svg";